import type { HashtagCampaignCatalogItem } from '@/types/hashtag.types';

export const normalizeHashtagSearchTerm = (value: string): string =>
  value.replace(/^#/, '').trim().toLowerCase();

/** DW/BQ `campaign_key` — lowercase, no leading `#`, trimmed. */
export const toCampaignKey = normalizeHashtagSearchTerm;

export const findCampaignBySearchTerm = (
  campaigns: HashtagCampaignCatalogItem[],
  searchTerm: string
): HashtagCampaignCatalogItem | undefined => {
  const needle = normalizeHashtagSearchTerm(searchTerm);
  if (!needle) return undefined;

  return campaigns.find(c => {
    const name = normalizeHashtagSearchTerm(c.name);
    const code = normalizeHashtagSearchTerm(c.hashtag_campaign_code);
    return name === needle || code === needle;
  });
};

export const formatHashtagDisplayName = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed) return '';
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
};

export const brandMatchesHashtagCampaign = (brandLabel: string, campaignName: string): boolean => {
  const brandNorm = normalizeHashtagSearchTerm(brandLabel);
  const nameNorm = normalizeHashtagSearchTerm(campaignName);
  return Boolean(nameNorm && (brandNorm === nameNorm || brandLabel.trim() === campaignName.trim()));
};
